var _rect, _g, _g2, _g3, _g4, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bgblur_0_3_1917_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.15374,
    y: -2.15374,
    width: 52.3075,
    height: 52.3075
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.08px)",
      height: "100%",
      width: "100%"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.15374,
    x: 0.489796,
    y: 0.489796,
    width: 47.0204,
    height: 47.0204,
    rx: 23.3469,
    fill: "url(#paint0_linear_3_1917)",
    stroke: "url(#paint1_linear_3_1917)",
    strokeWidth: 0.979592
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4092 16.486L22.4084 13.4941C22.1904 13.2767 22.1901 12.9237 22.4078 12.706C22.7758 12.3381 22.7758 11.7416 22.4078 11.3736C22.0399 11.0057 21.4433 11.0057 21.0754 11.3736L10.401 22.048C10.033 22.416 10.033 23.0125 10.401 23.3805C10.5856 23.5651 10.8267 23.6567 11.0678 23.6567C11.3089 23.6567 11.55 23.5651 11.7334 23.3805C11.9484 23.1655 12.297 23.1655 12.512 23.3805L15.5297 26.3982C16.1739 27.06 17.0417 27.4242 17.9748 27.4242C18.9079 27.4242 19.7756 27.06 20.4111 26.407L25.4255 21.3925C26.0873 20.7495 26.4515 19.8805 26.4515 18.9474C26.4515 18.0144 26.0873 17.1453 25.4092 16.486Z",
    fill: "#0062FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bgblur_1_3_1917_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.38596,
    y: 0.436742,
    width: 26.5464,
    height: 26.5463
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.33px)",
      height: "100%",
      width: "100%"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3_1917)",
    "data-figma-bg-blur-radius": 10.6609
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3486 16.3221C18.1126 16.3221 17.8766 16.2324 17.6971 16.0518L14.317 12.6718C13.9568 12.3117 13.9568 11.7279 14.317 11.3677C14.6771 11.0076 15.261 11.0076 15.6211 11.3677L19.0013 14.7477C19.3614 15.1078 19.3614 15.6916 19.0013 16.0518C18.8206 16.2324 18.5846 16.3221 18.3486 16.3221Z",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bgblur_2_3_1917_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.535914,
    y: 4.35471,
    width: 26.5464,
    height: 26.5463
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.33px)",
      height: "100%",
      width: "100%"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3_1917)",
    "data-figma-bg-blur-radius": 10.6609
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4267 20.2401C14.1907 20.2401 13.9547 20.1504 13.7753 19.9697L10.3951 16.5889C10.035 16.2287 10.035 15.6448 10.3951 15.2858C10.7552 14.9256 11.3391 14.9256 11.6992 15.2858L15.0794 18.6665C15.4395 19.0267 15.4395 19.6107 15.0794 19.9709C14.8987 20.1504 14.6627 20.2401 14.4267 20.2401Z",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bgblur_3_3_1917_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 10.2375,
    y: 11.8664,
    width: 40.9136,
    height: 40.2605
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.33px)",
      height: "100%",
      width: "100%"
    }
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3_1917)",
    "data-figma-bg-blur-radius": 10.6609
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5414 41.4661C39.2987 41.4661 39.056 41.374 38.8715 41.1884L35.7117 38.0323C34.3391 36.6613 32.1044 36.6613 30.7331 38.0323L30.1466 38.6181C29.1216 39.6406 27.7616 40.2037 26.3156 40.2037C23.3277 40.2037 20.8984 37.7773 20.8984 34.7929C20.8984 33.3486 21.4621 31.989 22.4847 30.9677L23.0711 30.3819C24.4438 29.0109 24.4438 26.7789 23.0711 25.4092L21.8047 24.1442C21.4343 23.7743 21.4343 23.1747 21.8047 22.8048C22.175 22.4349 22.7754 22.4349 23.1457 22.8048L24.4122 24.0697C26.5242 26.1793 26.5242 29.6118 24.4122 31.7214L23.8257 32.3071C23.1609 32.9712 22.7943 33.8536 22.7943 34.7929C22.7943 36.732 24.373 38.31 26.3156 38.31C27.256 38.31 28.1395 37.9439 28.8056 37.2799L29.392 36.6941C31.5041 34.5846 34.9407 34.5846 37.0527 36.6941L40.2125 39.8502C40.5829 40.2201 40.5829 40.8198 40.2125 41.1896C40.0267 41.374 39.7841 41.4661 39.5414 41.4661Z",
    fill: "#707070"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4092 16.486L22.0135 13.1004L22.4078 12.706C22.7758 12.3381 22.7758 11.7416 22.4078 11.3736C22.0399 11.0057 21.4433 11.0057 21.0754 11.3736L10.401 22.048C10.033 22.416 10.033 23.0125 10.401 23.3805C10.5856 23.5651 10.8267 23.6567 11.0678 23.6567C11.3089 23.6567 11.55 23.5651 11.7334 23.3805L12.1227 22.9912L15.5297 26.3982C16.1739 27.06 17.0417 27.4242 17.9748 27.4242C18.9079 27.4242 19.7756 27.06 20.4111 26.407L25.4255 21.3925C26.0873 20.7495 26.4515 19.8805 26.4515 18.9474C26.4515 18.0144 26.0873 17.1453 25.4092 16.486Z",
    fill: "url(#paint2_linear_3_1917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3_1917_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.489796,
    y: 0.489796,
    width: 47.0204,
    height: 47.0204,
    rx: 23.3469
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3_1917",
    x: 4.20222,
    y: 5.17488,
    width: 28.1722,
    height: 28.1721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.96139,
    result: "effect1_foregroundBlur_3_1917"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3_1917",
    x: 3.38596,
    y: 0.436742,
    width: 26.5464,
    height: 26.5463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.69217,
    dy: 2.69217
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69217
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.654902 0 0 0 0 0.407843 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_1917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_1917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_3_1917_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3486 16.3221C18.1126 16.3221 17.8766 16.2324 17.6971 16.0518L14.317 12.6718C13.9568 12.3117 13.9568 11.7279 14.317 11.3677C14.6771 11.0076 15.261 11.0076 15.6211 11.3677L19.0013 14.7477C19.3614 15.1078 19.3614 15.6916 19.0013 16.0518C18.8206 16.2324 18.5846 16.3221 18.3486 16.3221Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3_1917",
    x: -0.535914,
    y: 4.35471,
    width: 26.5464,
    height: 26.5463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.69217,
    dy: 2.69217
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69217
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.654902 0 0 0 0 0.407843 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_1917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_1917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_3_1917_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4267 20.2401C14.1907 20.2401 13.9547 20.1504 13.7753 19.9697L10.3951 16.5889C10.035 16.2287 10.035 15.6448 10.3951 15.2858C10.7552 14.9256 11.3391 14.9256 11.6992 15.2858L15.0794 18.6665C15.4395 19.0267 15.4395 19.6107 15.0794 19.9709C14.8987 20.1504 14.6627 20.2401 14.4267 20.2401Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3_1917",
    x: 10.2375,
    y: 11.8664,
    width: 40.9136,
    height: 40.2605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.69217,
    dy: 2.69217
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69217
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.654902 0 0 0 0 0.407843 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_1917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_1917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_3_1917_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5414 41.4661C39.2987 41.4661 39.056 41.374 38.8715 41.1884L35.7117 38.0323C34.3391 36.6613 32.1044 36.6613 30.7331 38.0323L30.1466 38.6181C29.1216 39.6406 27.7616 40.2037 26.3156 40.2037C23.3277 40.2037 20.8984 37.7773 20.8984 34.7929C20.8984 33.3486 21.4621 31.989 22.4847 30.9677L23.0711 30.3819C24.4438 29.0109 24.4438 26.7789 23.0711 25.4092L21.8047 24.1442C21.4343 23.7743 21.4343 23.1747 21.8047 22.8048C22.175 22.4349 22.7754 22.4349 23.1457 22.8048L24.4122 24.0697C26.5242 26.1793 26.5242 29.6118 24.4122 31.7214L23.8257 32.3071C23.1609 32.9712 22.7943 33.8536 22.7943 34.7929C22.7943 36.732 24.373 38.31 26.3156 38.31C27.256 38.31 28.1395 37.9439 28.8056 37.2799L29.392 36.6941C31.5041 34.5846 34.9407 34.5846 37.0527 36.6941L40.2125 39.8502C40.5829 40.2201 40.5829 40.8198 40.2125 41.1896C40.0267 41.374 39.7841 41.4661 39.5414 41.4661Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_1917",
    x1: 2.36287,
    y1: 2.6642,
    x2: 24,
    y2: 24.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_1917",
    x1: -10.112,
    y1: -3.45813,
    x2: 2.89239,
    y2: 57.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_1917",
    x1: 23.2156,
    y1: 17.9371,
    x2: 9.9037,
    y2: 21.9735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2567FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.280286fb3f53b47ff56a1d4e3786d2d7.svg";
export { ForwardRef as ReactComponent };